import React, { FunctionComponent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { InputBirthday, InputBirthdayValidity, InputOnChange, InputOnFocus } from '@afterpaytouch/core'
import { DateOfBirthFieldSchema } from '../../types'
import { useError, useVisible } from '../../utils/hooks'
import { useDobValidation } from './helper/helper'

export const DateOfBirthField: FunctionComponent<DateOfBirthFieldSchema> = ({ name = '', props, options, show = true, minAge, maxAge, testNameSpace = '' }) => {
  const { register, setValue } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const { isError, errorText } = useError({ name, error: props?.error, errorText: props?.errorText })
  const [validity, setValidity] = useState<InputBirthdayValidity>()
  const [revalidate, setRevalidate] = useState(false)
  const ageValidation = useDobValidation({ validity, minAgeMsg: minAge?.message, maxAgeMsg: maxAge?.message, requiredMsg: options?.required })
  const component = register(name, {
    ...options,
    validate: {
      ...ageValidation,
    },
    value: values ?? props?.defaultValue,
  })

  // This is to revalidate the dob when validity changes based on another field
  useEffect(() => {
    if (validity && revalidate) {
      setValue(name, values, {
        shouldValidate: revalidate,
      })
    }
  }, [validity, revalidate])

  const handleBlur = (e: InputOnFocus, isoDate: string, validity: InputBirthdayValidity): void => {
    component.onBlur(e)
    setValidity(validity)
    setRevalidate(true)
    setValue(name, isoDate, {
      shouldValidate: true,
      shouldTouch: true,
    })
  }

  const handleChange = (e: InputOnChange, isoDate: string, validity: InputBirthdayValidity): void => {
    setValidity(validity)
    setValue(name, isoDate, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: false,
    })
  }

  const handleValidationChange = (isoDate: string, validity: InputBirthdayValidity, revalidate: boolean): void => {
    setValidity(validity)
    setRevalidate(revalidate)
    setValue(name, isoDate, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
  }

  return isVisible ? (
    <InputBirthday
      {...props}
      {...component}
      defaultValue={props?.defaultValue}
      ref={component.ref}
      testNameSpace={testNameSpace}
      onBlur={handleBlur}
      onChange={handleChange}
      onValidationChange={handleValidationChange}
      error={isError}
      errorText={errorText}
      minAge={minAge?.value}
      maxAge={maxAge?.value}
      fullWidth
    />
  ) : null
}
